import { DATE_FULL_FORMAT } from '../../../../constants/date'
import { formatDate, TABLE_EMPTY_TEXT } from '../../../Table'
import {
  INTEGRATION_CONNECTION_TYPE,
  IntegrationsAction,
} from '../RentalPortalIntegrations.constants'

import { INTEGRATIONS_PANEL_FACT } from './RentalPortalIntegrationsPanel.constants'

function getIsIntegrationsConnectAction(action) {
  return action === IntegrationsAction.connect
}

export function getIntegrationsPanelFactValue({
  connection,
  locale,
  name,
  timezone,
}) {
  switch (name) {
    case INTEGRATIONS_PANEL_FACT.Account:
      return connection.account_label || TABLE_EMPTY_TEXT

    case INTEGRATIONS_PANEL_FACT.ConnectionType:
      return INTEGRATION_CONNECTION_TYPE[connection.portal] || TABLE_EMPTY_TEXT

    case INTEGRATIONS_PANEL_FACT.LastChecked:
      return connection.last_checked_at
        ? formatDate({
            date: connection.last_checked_at,
            dateFormat: DATE_FULL_FORMAT,
            locale,
            timezone,
            useTodayFormat: false,
          })
        : TABLE_EMPTY_TEXT

    default:
      return TABLE_EMPTY_TEXT
  }
}

export function getIntegrationsPanelPrimaryKey(hasConnection) {
  return hasConnection
    ? 'RentalPortal.IntegrationsReconnectBtnKey'
    : 'RentalPortal.IntegrationsConnectBtnKey'
}

export function getIntegrationsPanelPermissionBlockKey(canConfigure) {
  return canConfigure ? null : 'RentalPortal.IntegrationsNoPermissionTooltipKey'
}

export function getIntegrationsPanelConnectBlockKey({
  canConfigure,
  isPortalEnabled,
}) {
  return (
    getIntegrationsPanelPermissionBlockKey(canConfigure) ??
    (isPortalEnabled ? null : 'RentalPortal.IntegrationsNotEnabledTooltipKey')
  )
}

export function getIsIntegrationsConnectFormOpen({
  action,
  isCredentialConnect,
}) {
  return getIsIntegrationsConnectAction(action) && isCredentialConnect
}

export function getIsIntegrationsOauthModalOpen({
  action,
  isCredentialConnect,
}) {
  return getIsIntegrationsConnectAction(action) && !isCredentialConnect
}

export function getIsIntegrationsDisconnectAction(action) {
  return action === IntegrationsAction.disconnect
}
